/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ productName: NonNullable<unknown> }} Admin_Resource_Form_Select_Product_For_Member_BookingsInputs */

const en_admin_resource_form_select_product_for_member_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.productName} for member bookings`)
};

const de_admin_resource_form_select_product_for_member_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.productName} für Mitgliederbuchungen auswählen`)
};

const es_admin_resource_form_select_product_for_member_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccionar ${i?.productName} para reservas de miembros`)
};

const fr_admin_resource_form_select_product_for_member_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sélectionnez ${i?.productName} pour les réservations des membres`)
};

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */
const it_admin_resource_form_select_product_for_member_bookings = en_admin_resource_form_select_product_for_member_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_select_product_for_member_bookings = en_admin_resource_form_select_product_for_member_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */
const pl_admin_resource_form_select_product_for_member_bookings = en_admin_resource_form_select_product_for_member_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */
const hu_admin_resource_form_select_product_for_member_bookings = en_admin_resource_form_select_product_for_member_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs) => LocalizedString} */
const ro_admin_resource_form_select_product_for_member_bookings = en_admin_resource_form_select_product_for_member_bookings;

/**
* | output |
* | --- |
* | "Select {productName} for member bookings" |
*
* @param {Admin_Resource_Form_Select_Product_For_Member_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_select_product_for_member_bookings = /** @type {((inputs: Admin_Resource_Form_Select_Product_For_Member_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Select_Product_For_Member_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_select_product_for_member_bookings(inputs)
	if (locale === "de") return de_admin_resource_form_select_product_for_member_bookings(inputs)
	if (locale === "es") return es_admin_resource_form_select_product_for_member_bookings(inputs)
	if (locale === "fr") return fr_admin_resource_form_select_product_for_member_bookings(inputs)
	if (locale === "it") return it_admin_resource_form_select_product_for_member_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_select_product_for_member_bookings(inputs)
	if (locale === "pl") return pl_admin_resource_form_select_product_for_member_bookings(inputs)
	if (locale === "hu") return hu_admin_resource_form_select_product_for_member_bookings(inputs)
	return ro_admin_resource_form_select_product_for_member_bookings(inputs)
});
export { admin_resource_form_select_product_for_member_bookings as "admin.resource_form.select_product_for_member_bookings" }